import React, { useState } from 'react';
import { Button } from '../Button';
import { Section } from '../Section';

export function FAQ({
  head = 'Frequently Asked Questions',
  questions = [],
  maxShow = 3,
  onHelpPage = false
}) {

  return (
    <Section className="tw-flex tw-flex-col tw-items-center">
      <h2 className="tw-text-center tw-text-black tw-mb-8">{head}</h2>

      <FAQContent questions={questions} maxShow={maxShow} onHelpPage={onHelpPage} />
    </Section>
  );
}

export const FAQContent = ({ questions = [], maxShow = 3, onHelpPage = false }) => {
  const [visibleCount, setVisibleCount] = useState(maxShow);

  const handleShowMore = () => {
    setVisibleCount((prev) => prev + 3);
  };

  const visibleQuestions = questions.slice(0, visibleCount);
  const hasMoreQuestions = visibleCount < questions.length;

  return (
    <>
      <div className="tw-w-full md:tw-max-w-4xl tw-space-y-8">
        {visibleQuestions.map((q, i) => (
          <details
            className="tw-group [&_summary::-webkit-details-marker]:tw-hidden tw-pb-2"
            key={i}
            open={i === 0}
            style={{
              borderBottom: i === visibleQuestions.length - 1 ? 'none' : '1px solid #E5E7EB',
            }}
          >
            <summary className="tw-flex tw-cursor-pointer tw-items-center tw-justify-between tw-text-gray-900">
              <h6 className="tw-tracking-tight tw-font-semibold">{q.question}</h6>

              <span className="tw-relative tw-h-5 tw-w-5 tw-shrink-0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="tw-absolute tw-inset-0 tw-h-5 tw-w-5 tw-opacity-100 group-open:tw-opacity-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="tw-absolute tw-inset-0 tw-h-5 tw-w-5 tw-opacity-0 group-open:tw-opacity-100"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </span>
            </summary>

            <p className="tw-p tw-mt-5 tw-tracking-tight">
              {q.answer}
            </p>
          </details>
        ))}
      </div>

      {(hasMoreQuestions || !onHelpPage) && (
        <Button
          outline
          title={onHelpPage ? 'Show more' : 'View all'}
          className="tw-text-primary"
          style={{ border: '0', padding: '0' }}
          {...(onHelpPage
            ? { onClick: handleShowMore }
            : { href: '/help-center' })}
        />
      )}
    </>
  )
}
